<template>
  <v-dialog v-model="dialog" persistent style="overflow-x: hidden;" width="25%">
    <!-- hide-overlay
    transition="none"-->
    <v-card>
      <v-layout text-xs-center>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-start row mx-3 mt-3 mb-0 align-center>
            <v-flex>
              <v-layout row>
                <div class="text-xs-left" style="font-size: 20px; ">
                  You are about to execute report:
                  <br />
                  <strong>{{reportId}} - {{reportName}}</strong>
                </div>
              </v-layout>
            </v-flex>
            <v-flex>
              <!-- <v-layout row>
                  <v-flex>
                    <v-layout class="buttons mb-0 mr-0" justify-end align-top row>
                      <v-btn icon @click="cancel" class="pa-0 ma-0">
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-flex>
              </v-layout>-->
            </v-flex>
          </v-layout>
          <v-layout mx-3>
            <v-flex>
              <v-layout column>
                <v-flex
                  class="text-xs-left mt-1"
                  v-if="(autorun==false)&&(reportParameters != null ? hiddenCount!=reportParameters.length:false)"
                >Please Specify:</v-flex>
                <v-form v-model="valid" @submit="runReport" ref="runReportForm">
                  <v-flex v-for="(parameter, index) in reportParameters" :key="index">
                    <v-autocomplete
                      v-if="parameter.ParameterType == 'DDL'"
                      :label="parameter.formLabel+'*'"
                      :items="parameter.formObject"
                      item-value="Value"
                      item-text="Text"
                      v-model="reportRun[`${parameter.formId}`]"
                      :rules="requiredRules"
                    ></v-autocomplete>
                    <v-text-field
                      v-if="parameter.ParameterType == 'TEXT'"
                      :label="parameter.formLabel+'*'"
                      :maxlength="parameter.formTextMaxLength"
                      v-model="reportRun[`${parameter.formId}`]"
                      :rules="requiredRules"
                    ></v-text-field>
                    <v-text-field
                      v-if="parameter.ParameterType == 'CURR'"
                      type="number"
                      :label="parameter.formLabel+'*'"
                      :maxlength="parameter.formTextMaxLength"
                      v-model.number="reportRun[`${parameter.formId}`]"
                      :rules="currencyRules"
                    ></v-text-field>
                    <v-menu
                      ref="months"
                      v-model="menuMonth[parameter.formId]"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="dateMonth[`${parameter.formId}`]"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-if="parameter.ParameterType == 'MONTH'"
                          :value="formatMonth(dateMonth[`${parameter.formId}`])"
                          :label="parameter.formLabel+'*'"
                          prepend-icon="fa-calendar-alt"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="monthPicker"
                        v-model="dateMonth[`${parameter.formId}`]"
                        type="month"
                        no-title
                        @input="saveMonth(index, parameter.formId)"
                      ></v-date-picker>
                    </v-menu>
                    <v-menu
                      ref="years"
                      v-model="menuYear[parameter.formId]"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="dateYear[`${parameter.formId}`]"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-if="parameter.ParameterType == 'YEAR'"
                          :value="formatYear(dateYear[`${parameter.formId}`])"
                          :label="parameter.formLabel+'*'"
                          prepend-icon="fa-calendar-alt"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="yearPicker"
                        v-model="dateYear[`${parameter.formId}`]"
                        type="year"
                        no-title
                        :min="minYear"
                        :max="maxYear"
                        @input="saveYear(index, parameter.formId); menuYear[parameter.formId] = false"
                      ></v-date-picker>
                    </v-menu>
                    <v-menu
                      ref="dateDate"
                      v-if="parameter.ParameterType == 'DATE'"
                      v-model="menuDate[parameter.formId]"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="dateDate[`${parameter.formId}`]"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-if="parameter.ParameterType == 'DATE'"
                          :value="formatDate(dateDate[`${parameter.formId}`])"
                          :label="parameter.formLabel+'*'"
                          prepend-icon="fa-calendar-alt"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="datePicker"
                        v-if="parameter.ParameterType == 'DATE'"
                        v-model="dateDate[`${parameter.formId}`]"
                        no-title
                        :min="minYear"
                        :max="maxYear"
                        @input="saveDate(index, parameter.formId);"
                      ></v-date-picker>
                    </v-menu>
                    <!-- <v-menu
                      ref="menuYear"
                      :close-on-content-click="false"
                      v-model="menuYear"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                      v-if="parameter.ParameterType == 'MONTH'"
                        slot="activator"
                        v-model="date"
                        :label="parameter.formLabel+'*'"
                        prepend-icon="fa-event"
                        readonly
                      ></v-text-field>
                      <v-date-picker ref="pickerYear" v-model="date" @input="saveYear" reactive no-title></v-date-picker>
                    </v-menu>-->
                    <!-- <v-input
                      v-if="parameter.ParameterType == 'HIDDEN'"
                      type="hidden"
                      :value="parameter.formDefaultValue"
                      @blur="reportRun[`${parameter.formId}`] = parameter.formDefaultValue"
                    />-->
                    <!-- @change="reportRun[`${parameter.formId}`]=$event.target.value" -->
                  </v-flex>
                </v-form>

                <!-- <div
                    class="text-xs-left"
                    style="font-size: 20px; font-weight: 600;"
                  >test</div>
                </v-layout>
                <v-layout row >
                  <div
                    class="text-xs-left"
                    style="font-size: 20px; font-weight: 600;"
                  >tester</div>
                </v-layout>
                
                <v-layout>
                  <div
                    class="text-xs-left mt-2"
                    style="font-size: 18px;"
                >testtest</div>-->
              </v-layout>
            </v-flex>
          </v-layout>
          <v-flex v-if="autorun==true" style="height:20px!important;"></v-flex>
          <v-card-actions>
            <v-flex mb-3>
              <v-layout>
                <v-flex>
                  <v-btn color="red" dark @click="cancel">Cancel</v-btn>
                </v-flex>
                <v-flex>
                  <v-btn color="green" dark @click="runReport">Run</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-actions>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import moment from "moment";

import Bus from "../../bus";

export default {
  name: "ReportsRun",

  components: {},

  data: () => ({
    dialog: false,
    search: "",
    loading: true,
    dateYear: [],
    dateMonth: [],
    menuYear: [],
    menuMonth: [],
    dateDate: [],
    menuDate: [],

    showResetBtn: false,

    filters: {},
    reportId: null,
    reportParameters: [],
    reportRun: {},
    autorun: null,
    reportName: null,
    hiddenCount: 0,
    requiredRules: [v => !!v || "Required"],
    currencyRules: [
      v =>
        new RegExp("^\\d+(?:\\.\\d{0,2})?$").test(v) ||
        "Must be in currency format",
      v => !!v || "Required"
    ],
    valid: true
  }),

  watch: {
    dialog(val) {
      val || this.cancel();
    }
  },
  computed: {
    minYear() {
      return moment()
        .subtract(10, "years")
        .format("YYYY-MM")
        .toString();
    },
    maxYear() {
      return moment()
        .add(10, "years")
        .format("YYYY-MM")
        .toString();
    }
  },

  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    }
  },

  methods: {
    async initialize() {},

    // Get data for elements in component from response data props
    async getElementData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },

    // Get data for props of elements
    async getPropData(url, obj, prop) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`][`${prop}`] = resp.data))
        .catch(err => console.log(err));
    },

    // Get data for elements in component from response data
    async getResponseData(url, obj) {
      await axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data))
        .catch(err => console.log(err));
    },

    async open(item) {
      this.hiddenCount = 0;
      this.reportId = item.reportId;
      this.reportParameters = await item.reportParameters;
      this.autorun = item.autorun;
      this.reportName = item.reportName;

      this.populateHidden();
      this.dialog = true;
    },
    async cancel() {
      this.dialog = await false;
      this.dateYear = [];
      this.dateMonth = [];
      this.menuYear = [];
      this.menuMonth = [];
      // this.reportId = null;
      this.reportRun = {};
      // this.autorun = null;
      // this.reportName= null

      //   this.resetFormFilters()
    },
    async runReport() {
      var reportId = this.reportId;
      var reportRun = this.reportRun;
      var autorun = this.autorun;
      if (
        reportId == "all" ||
        typeof reportId == "undefined" ||
        reportId == null ||
        typeof autorun == "undefined" ||
        autorun == null
      ) {
        //do nothing
      } else {
        if (autorun == true) {
          await axios
            .post("/api/Report/RunAutoRunReport/" + reportId)
            .then(res => {
              this.$root.$emit("initialize", this.initialize);
              Bus.$emit("alert", {
                color: "success",
                message: "Report Submitted Successfully!"
              });
              this.cancel();
            });
        } else if (autorun == false) {
          if (this.$refs.runReportForm.validate()) {
            if (typeof reportRun == "undefined" || reportRun == null) {
              //do nothing
            } else {
              await axios
                .post("/api/Report/PostRunReport/" + reportId, reportRun)
                .then(res => {
                  this.$root.$emit("initialize", this.initialize);
                  Bus.$emit("alert", {
                    color: "success",
                    message: "Report Submitted Successfully!"
                  });
                  this.cancel();
                });
            }
          }
        }
      }
    },
    populateHidden() {
      if (this.reportParameters) {
        this.reportParameters.forEach(parameter => {
          if (parameter.ParameterType == "HIDDEN") {
            this.reportRun[`${parameter.formId}`] = parameter.formDefaultValue;
            this.hiddenCount += 1;
          }
        });
      }
    },
    //  saveYear (date) {
    //   this.$refs.menuYear.save(date);
    //   this.$refs.pickerYear.activePicker = 'YEAR'
    //   this.menuYear = false;
    // },
    saveYear(index, id) {
      this.$refs.years[index].save(this.dateYear[`${id}`]);
      this.reportRun[`${id}`] = moment(
        this.dateYear[`${id}`],
        "YYYY-MM"
      ).format("YYYY");
      this.$refs.yearPicker[index].activePicker = "YEAR";
      this.$nextTick(
        () => (this.$refs.yearPicker[index].activePicker = "YEAR")
      );
      this.menuYear[`${id}`] = false;
    },
    saveMonth(index, id) {
      this.$refs.months[index].save(this.dateMonth[`${id}`]);
      this.reportRun[`${id}`] = moment(
        this.dateMonth[`${id}`],
        "YYYY-MM"
      ).format("MM");
      this.menuMonth[`${id}`] = false;
    },
    saveDate(index, id) {
      this.$refs.dateDate[index].save(this.dateDate[`${id}`]);
      this.reportRun[`${id}`] = moment(
        this.dateDate[`${id}`],
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD");
      this.menuDate[`${id}`] = false;
    },
    formatYear(year) {
      if (year) {
        return moment(year, "YYYY-MM")
          .format("YYYY")
          .toString();
      }
    },
    formatMonth(month) {
      if (month) {
        return moment(month, "YYYY-MM")
          .format("MM")
          .toString();
      }
    },
    formatDate(date) {
      if (date) {
        return moment(date, "YYYY-MM-DD")
          .format("YYYY-MM-DD")
          .toString();
      }
    }
  }
};
</script>

<style scoped>
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>
